import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import AnimatedSection from '@/components/ui/AnimatedSection';
import EventCard from '@/components/agenda/EventCard';
import { useUpcomingEvents } from '@/hooks/useEvents';

export default function UpcomingEvents() {
    const { data: events, isLoading } = useUpcomingEvents(6);

    return (
        <section className="py-28 bg-gray-50">
            <div className="container mx-auto px-6">
                <div className="flex flex-col md:flex-row md:items-end justify-between mb-12 gap-6">
                    <AnimatedSection>
                        <div className="inline-block px-3 py-1 bg-primary-100 text-primary-700 rounded-full text-sm font-bold mb-4">
                            Agenda
                        </div>
                        <h2 className="text-4xl md:text-5xl font-serif font-bold text-primary-900">
                            Prochaines <span className="text-accent-500">Activités</span>
                        </h2>
                    </AnimatedSection>

                    <AnimatedSection delay={0.2}>
                        <Link
                            to="/agenda"
                            className="group inline-flex items-center gap-2 font-medium text-primary-600 hover:text-primary-800 transition-colors"
                        >
                            Tout voir
                            <ArrowRight size={20} className="transition-transform group-hover:translate-x-1" />
                        </Link>
                    </AnimatedSection>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                    {!isLoading && events?.map((event, index) => (
                        <AnimatedSection key={event.id} delay={index * 0.1}>
                            <EventCard event={event} showImage={true} />
                        </AnimatedSection>
                    ))}

                    {isLoading && (
                        // Simple Skeleton
                        [1, 2, 3, 4, 5, 6].map((i) => (
                            <div key={i} className="h-[450px] bg-white rounded-xl shadow-sm animate-pulse border border-gray-100">
                                <div className="h-48 bg-gray-200" />
                                <div className="p-6 space-y-4">
                                    <div className="h-4 bg-gray-200 w-1/3 rounded" />
                                    <div className="h-8 bg-gray-200 w-3/4 rounded" />
                                    <div className="h-4 bg-gray-200 w-full rounded" />
                                    <div className="h-4 bg-gray-200 w-full rounded" />
                                </div>
                            </div>
                        ))
                    )}
                </div>
            </div>
        </section>
    );
}
